import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';
import { Link } from 'react-router-dom';
import './KioskDisplayPage.css';

const POLL_INTERVAL = 2500;

function KioskDisplayPage() {
  const [waiting, setWaiting] = useState(0);
  const uploadUrl = `${window.location.origin}/search-qr/upload`;

  useEffect(() => {
    const tick = async () => {
      try {
        const { data } = await axios.get('/api/kiosk/queue');
        setWaiting((data || []).filter((item) => item.status === 'pending').length);
      } catch (error) {
        console.error('Error fetching kiosk queue:', error);
      }
    };
    tick();
    const interval = setInterval(tick, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="kiosk-page kiosk-idle">
      <div className="kiosk-brand">
        <img src="/logo.png" alt="" className="kiosk-brand-logo" />
        <span className="kiosk-brand-word">ATLAS <span className="accent">- COMPASS</span></span>
      </div>
      <h3 className="kiosk-idle-title">search movies by a single photo</h3>
      <ol className="kiosk-idle-steps">
        <li>Scan the QR code</li>
        <li>Upload a selfie or a photo you like</li>
        <li>Discover movies that match your style</li>
      </ol>
      <div className="kiosk-qr-frame">
        <QRCodeSVG value={uploadUrl} size={320} bgColor="transparent" fgColor="#f5f3ef" level="M" />
      </div>
      {waiting > 0 && (
        <p className="kiosk-queue-note">{waiting} waiting in line</p>
      )}
      <Link className="kiosk-staff-link" to="/search-qr/results">Results screen</Link>
    </div>
  );
}

export default KioskDisplayPage;
